/* jshint esversion: 6 */
/* jshint esversion: 8 */
/* jshint esversion: 11 */
/* jshint ignore:start */
import { useContext, useEffect, useState } from "react";
import {
  LocalUser,
  RemoteUser,
  useIsConnected,
  useJoin,
  useLocalMicrophoneTrack,
  useLocalCameraTrack,
  usePublish,
  useRemoteUsers,
} from "agora-rtc-react";
import { MyContext } from "../../Context/MyProvider";
import { FiMicOff, FiMic } from "react-icons/fi";
import { FaVideo, FaVideoSlash } from "react-icons/fa";
import { IoCall } from "react-icons/io5";
import secureLocalStorage from "react-secure-storage";
import ImageLoad from "../ImageLoad";
import { useTranslation } from "react-i18next";

const AgoraCallView = ({
  Data,
  channel,
  token,
  micOn,
  setMic,
  cameraOn,
  setCamera,
  LeaveCall,
  calling,
}) => {
  const { t } = useTranslation();

  const { ImgBaseUrl, agoraAppId } = useContext(MyContext);
  const [userImg, setUserImg] = useState("");
  const isConnected = useIsConnected();
  const { localMicrophoneTrack } = useLocalMicrophoneTrack(calling);
  const { localCameraTrack } = useLocalCameraTrack(calling);
  const remoteUsers = useRemoteUsers();

  useJoin({ appid: agoraAppId, channel, token }, calling);
  usePublish(calling ? [localMicrophoneTrack, localCameraTrack] : []);

  useEffect(() => {
    const Loginuser = secureLocalStorage.getItem("Loginuser");
    if (Loginuser) {
      const { image } = JSON.parse(Loginuser);
      setUserImg(image);
    }
    return () => {
      if (localMicrophoneTrack) {
        try {
          localMicrophoneTrack.stop();
          localMicrophoneTrack.close();
        } catch (e) {
          console.error("Error closing microphone track:", e);
        }
      }
      if (localCameraTrack) {
        try {
          localCameraTrack.stop();
          localCameraTrack.close();
        } catch (e) {
          console.error("Error closing camera track:", e);
        }
      }
    };
  }, [localMicrophoneTrack, localCameraTrack]);

  const toggleMic = () => {
    if (localMicrophoneTrack) {
      localMicrophoneTrack
        .setMuted(!micOn)
        .catch((e) => console.error("Error muting mic:", e));
    }
    setMic(!micOn);
  };

  const toggleCamera = () => {
    if (localCameraTrack) {
      localCameraTrack
        .setEnabled(!cameraOn)
        .catch((e) => console.error("Error setting camera enabled:", e));
    }
    setCamera(!cameraOn);
  };

  return (
    <div className="flex flex-col h-[100%] justify-between relative bg-slate-955 rounded-xl overflow-hidden shadow-2xl border border-slate-800">
      <div className="flex-1 relative w-full h-[380px] bg-slate-900">
        {isConnected ? (
          <div className="w-full h-full relative">
            {remoteUsers.length > 0 ? (
              remoteUsers.map((user) => (
                <div
                  className="w-full h-full absolute inset-0 z-10"
                  key={user.uid}
                >
                  <RemoteUser
                    cover={ImgBaseUrl + Data?.logo}
                    user={user}
                    className="w-full h-full object-cover"
                  />
                </div>
              ))
            ) : (
              <div className="absolute inset-0 flex flex-col items-center justify-center bg-slate-900/90 text-white font-medium text-sm gap-3 z-0">
                <div className="w-16 h-16 rounded-full overflow-hidden border-2 border-indigo-500 shadow-lg animate-pulse mb-2">
                  <img
                    src={ImgBaseUrl + Data?.logo}
                    alt={Data?.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <span className="text-slate-200 font-semibold tracking-wide">
                  {Data?.name}
                </span>
                <span className="text-slate-400 text-xs animate-pulse">
                  {t("Connecting to call...")}
                </span>
              </div>
            )}

            {cameraOn && (
              <div className="absolute top-4 left-4 w-[100px] h-[130px] z-20 rounded-lg overflow-hidden border border-slate-700/80 shadow-2xl bg-slate-850">
                <LocalUser
                  audioTrack={localMicrophoneTrack}
                  cameraOn={cameraOn}
                  micOn={micOn}
                  videoTrack={localCameraTrack}
                  cover="https://www.agora.io/en/wp-content/uploads/2022/10/3d-spatial-audio-icon.svg"
                />
              </div>
            )}
            {!cameraOn && (
              <div className="absolute top-4 left-4 w-[100px] h-[130px] z-20 rounded-lg overflow-hidden border border-slate-700/80 shadow-2xl bg-slate-850">
                <ImageLoad
                  src={ImgBaseUrl + userImg}
                  CustomeStyle={"w-[100%] h-[100%] object-cover"}
                  alt={"logo"}
                  index={1}
                />
              </div>
            )}
          </div>
        ) : (
          <div className="absolute inset-0 flex flex-col items-center justify-center bg-slate-950 text-white font-medium text-sm gap-2">
            <div className="w-10 h-10 border-4 border-indigo-500 border-t-transparent rounded-full animate-spin"></div>
            <span className="text-slate-400 mt-2">
              {t("Joining Agora Channel...")}
            </span>
          </div>
        )}
      </div>

      <div className="absolute bottom-5 left-0 right-0 flex justify-center gap-4 z-30 px-4">
        <button
          className={`p-3.5 rounded-full transition-all duration-300 shadow-xl border ${micOn ? "bg-slate-800/80 hover:bg-slate-700/90 text-white border-slate-750" : "bg-red-500/95 hover:bg-red-650 text-white border-transparent"}`}
          onClick={toggleMic}
        >
          {micOn ? <FiMic size={18} /> : <FiMicOff size={18} />}
        </button>
        <button
          className={`p-3.5 rounded-full transition-all duration-300 shadow-xl border ${cameraOn ? "bg-slate-800/80 hover:bg-slate-700/90 text-white border-slate-750" : "bg-red-500/95 hover:bg-red-650 text-white border-transparent"}`}
          onClick={toggleCamera}
        >
          {cameraOn ? <FaVideo size={18} /> : <FaVideoSlash size={18} />}
        </button>
        <button
          className="p-3.5 bg-red-600 hover:bg-red-500 rounded-full text-white transition-all duration-300 shadow-xl border border-transparent hover:scale-105"
          onClick={LeaveCall}
        >
          <IoCall size={18} />
        </button>
      </div>
    </div>
  );
};

export default AgoraCallView;
/* jshint ignore:end */
